import controller from './users-and-access.controller';

const template = require('./users-and-access.html');

export default {
    controller,
    template
};



// WEBPACK FOOTER //
// ./app/components/users-and-access/users-and-access.component.js